// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepStrip-module__strip___HqZMW {
  container-type: inline-size;
  margin-top: 16px;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
}

.StepStrip-module__panel___YhNPR {
  padding: 16px 20px;
  border-radius: 9px;
  background: #173530;
}
.StepStrip-module__panel___YhNPR:not(:last-child) {
  border-radius: 9px 9px 0 0;
}

.StepStrip-module__stages___zUksO {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
}

.StepStrip-module__stage___DVhxv {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.StepStrip-module__stageHead___tbh52 {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 20px;
}

.StepStrip-module__stageName___EVKpL {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(177, 209, 247, 0.85);
}

.StepStrip-module__asNeeded___HJ2io {
  font-size: 13px;
  line-height: 18.6px;
  color: rgba(255, 255, 255, 0.6);
}

.StepStrip-module__hairline___A1cX7 {
  flex: 1;
  min-width: 26px;
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
}

.StepStrip-module__steps___ePgqb {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.StepStrip-module__pill___qXLDV {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 13px 0 4px;
  border: 0;
  border-radius: 999px;
  background: #274544;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 150ms;
}
.StepStrip-module__pill___qXLDV:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}
.StepStrip-module__pill___qXLDV:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #173530, 0 0 0 4px #fff;
}

.StepStrip-module__pillOff___bJINU {
  background: rgba(39, 69, 68, 0.5);
  color: rgba(255, 255, 255, 0.45);
  cursor: not-allowed;
}
.StepStrip-module__pillOff___bJINU:hover {
  background: rgba(39, 69, 68, 0.5);
  color: rgba(255, 255, 255, 0.45);
}

.StepStrip-module__mark___OZHPQ {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #b1d1f7;
  color: #173530;
}

.StepStrip-module__pillOff___bJINU .StepStrip-module__mark___OZHPQ {
  background: rgba(177, 209, 247, 0.4);
}

.StepStrip-module__label___i4M0N {
  white-space: nowrap;
}

.StepStrip-module__count___CEOyH {
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: #fff;
}

.StepStrip-module__arrow___xOh21 {
  flex-shrink: 0;
}

.StepStrip-module__why___BIqVO {
  pointer-events: none;
}

.StepStrip-module__srOnly___SjgdG {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  clip-path: inset(50%);
  white-space: nowrap;
}

.StepStrip-module__footer___KTBM8 {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 13px 20px;
  border-radius: 0 0 9px 9px;
  background: #fbf7f1;
}

.StepStrip-module__footerTile___K_ncs {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #173530;
  color: #fff;
}

.StepStrip-module__footerText___f5Wf7 {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 15px;
  line-height: 1.375;
}

.StepStrip-module__footerTitle___fdS8K {
  font-weight: 600;
  color: #18181b;
}

.StepStrip-module__footerDesc___JPuMc {
  color: #52525b;
}

.StepStrip-module__openDraft___PVZvi {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 13px 0 16px;
  border: 0;
  border-radius: 999px;
  background: #173530;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #fff;
  cursor: pointer;
  transition: background-color 150ms;
}
.StepStrip-module__openDraft___PVZvi:hover {
  background: #274544;
}
.StepStrip-module__openDraft___PVZvi:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

@container (min-width: 672px) {
  .StepStrip-module__stage___DVhxv {
    flex: 1 1 auto;
    width: auto;
  }
}
@container (max-width: 511px) {
  .StepStrip-module__footer___KTBM8 {
    flex-direction: column;
    align-items: flex-start;
  }
  .StepStrip-module__footerTitle___fdS8K,
  .StepStrip-module__footerDesc___JPuMc {
    display: block;
  }
}
@container (max-width: 447px) {
  .StepStrip-module__panel___YhNPR,
  .StepStrip-module__footer___KTBM8 {
    padding-right: 16px;
    padding-left: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/StepStrip.module.scss"],"names":[],"mappings":"AAKA;EACE,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,mBAfM;AAWR;AAME;EACE,0BAAA;AAJJ;;AAQA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AALF;;AAQA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gCAAA;AALF;;AAQA;EACE,eAAA;EACA,mBAAA;EACA,+BAAA;AALF;;AAQA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAlFO;EAmFP,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kCAAA;AALF;AAOE;EACE,qCAAA;EACA,WAAA;AALJ;AAQE;EACE,aAAA;EACA,6CACE;AAPN;;AAYA;EACE,iCAAA;EACA,gCAAA;EACA,mBAAA;AATF;AAWE;EACE,iCAAA;EACA,gCAAA;AATJ;;AAaA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBA3HO;EA4HP,cA9HM;AAoHR;;AAaA;EACE,oCAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,oBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAzKO;AA+JT;;AAaA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAvLM;EAwLN,WAAA;AAVF;;AAaA;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;EACA,mBArNM;EAsNN,wEACE;EAEF,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,kCAAA;AAZF;AAcE;EACE,mBAjOK;AAqNT;AAeE;EACE,0BAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE;IACE,cAAA;IACA,WAAA;EAdF;AACF;AAiBA;EACE;IACE,sBAAA;IACA,uBAAA;EAfF;EAkBA;;IAEE,cAAA;EAhBF;AACF;AAmBA;EACE;;IAEE,mBAAA;IACA,kBAAA;EAjBF;AACF","sourcesContent":["$panel: #173530;\n$raised: #274544;\n$active: #b1d1f7;\n$footer: #fbf7f1;\n\n.strip {\n  container-type: inline-size;\n  margin-top: 16px;\n  border: 1px solid #e4e4e7;\n  border-radius: 10px;\n}\n\n.panel {\n  padding: 16px 20px;\n  border-radius: 9px;\n  background: $panel;\n\n  &:not(:last-child) {\n    border-radius: 9px 9px 0 0;\n  }\n}\n\n.stages {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 20px;\n}\n\n.stage {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.stageHead {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 20px;\n}\n\n.stageName {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba($active, 0.85);\n}\n\n.asNeeded {\n  font-size: 13px;\n  line-height: 18.6px;\n  color: rgba(#fff, 0.6);\n}\n\n.hairline {\n  flex: 1;\n  min-width: 26px;\n  height: 1px;\n  background: rgba(#fff, 0.15);\n}\n\n.steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 13px 0 4px;\n  border: 0;\n  border-radius: 999px;\n  background: $raised;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 150ms;\n\n  &:hover {\n    background: rgba(#fff, 0.15);\n    color: #fff;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow:\n      0 0 0 2px $panel,\n      0 0 0 4px #fff;\n  }\n}\n\n.pillOff {\n  background: rgba($raised, 0.5);\n  color: rgba(#fff, 0.45);\n  cursor: not-allowed;\n\n  &:hover {\n    background: rgba($raised, 0.5);\n    color: rgba(#fff, 0.45);\n  }\n}\n\n.mark {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: $active;\n  color: $panel;\n}\n\n.pillOff .mark {\n  background: rgba($active, 0.4);\n}\n\n.label {\n  white-space: nowrap;\n}\n\n.count {\n  padding: 0 6px;\n  border-radius: 999px;\n  background: rgba(#fff, 0.15);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #fff;\n}\n\n.arrow {\n  flex-shrink: 0;\n}\n\n.why {\n  pointer-events: none;\n}\n\n.srOnly {\n  position: absolute;\n  overflow: hidden;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  padding: 13px 20px;\n  border-radius: 0 0 9px 9px;\n  background: $footer;\n}\n\n.footerTile {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: $panel;\n  color: #fff;\n}\n\n.footerText {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.375;\n}\n\n.footerTitle {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.footerDesc {\n  color: #52525b;\n}\n\n.openDraft {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 4px;\n  height: 36px;\n  padding: 0 13px 0 16px;\n  border: 0;\n  border-radius: 999px;\n  background: $panel;\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.07),\n    0 2px 4px rgba(0, 0, 0, 0.04);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 21px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 150ms;\n\n  &:hover {\n    background: $raised;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #18181b;\n    outline-offset: 1px;\n  }\n}\n\n@container (min-width: 672px) {\n  .stage {\n    flex: 1 1 auto;\n    width: auto;\n  }\n}\n\n@container (max-width: 511px) {\n  .footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .footerTitle,\n  .footerDesc {\n    display: block;\n  }\n}\n\n@container (max-width: 447px) {\n  .panel,\n  .footer {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip": `StepStrip-module__strip___HqZMW`,
	"panel": `StepStrip-module__panel___YhNPR`,
	"stages": `StepStrip-module__stages___zUksO`,
	"stage": `StepStrip-module__stage___DVhxv`,
	"stageHead": `StepStrip-module__stageHead___tbh52`,
	"stageName": `StepStrip-module__stageName___EVKpL`,
	"asNeeded": `StepStrip-module__asNeeded___HJ2io`,
	"hairline": `StepStrip-module__hairline___A1cX7`,
	"steps": `StepStrip-module__steps___ePgqb`,
	"pill": `StepStrip-module__pill___qXLDV`,
	"pillOff": `StepStrip-module__pillOff___bJINU`,
	"mark": `StepStrip-module__mark___OZHPQ`,
	"label": `StepStrip-module__label___i4M0N`,
	"count": `StepStrip-module__count___CEOyH`,
	"arrow": `StepStrip-module__arrow___xOh21`,
	"why": `StepStrip-module__why___BIqVO`,
	"srOnly": `StepStrip-module__srOnly___SjgdG`,
	"footer": `StepStrip-module__footer___KTBM8`,
	"footerTile": `StepStrip-module__footerTile___K_ncs`,
	"footerText": `StepStrip-module__footerText___f5Wf7`,
	"footerTitle": `StepStrip-module__footerTitle___fdS8K`,
	"footerDesc": `StepStrip-module__footerDesc___JPuMc`,
	"openDraft": `StepStrip-module__openDraft___PVZvi`
};
module.exports = ___CSS_LOADER_EXPORT___;
